import { useIntl } from 'react-intl'
import React from 'react'
import { quotes } from './quotes'
import { TPKColors } from '../../../colors'
import {
    renderCenterLeftControls,
    renderCenterRightControls
} from '../carousel'
import {
    StyledTiltedText,
    StyledTiltedTextContainer
} from '../../../components/styles'
import { Nl2Br } from '../nl2br/Nl2Br'
//$FlowFixMe
import mask from 'app/tu-preferes-king/assets/mask.webp'
import { useWindowDimensions } from '../../../utils'
import { breakpoints } from '../../../../assets/styles'
import styled from 'styled-components'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { colors } from 'app-v2/design-systems/theme/colors'
import { media } from 'app/assets/styles'
import CarouselElement from 'nuka-carousel'
import { BORDER, SPACING } from '../../../../../app-v2/design-tokens'

export const QuoteCarousel = () => {
    const intl = useIntl()
    const { width: windowWidth } = useWindowDimensions()
    const isSmall = windowWidth <= breakpoints.small
    return (
        <StyledCarouselFullPageContainer>
            {!isSmall && (
                <StyledIconContainer>
                    <img src={mask} alt={'mask'} />
                </StyledIconContainer>
            )}
            <StyledCarouselContainer>
                <StyledCarousel
                    adaptiveHeight
                    renderCenterLeftControls={renderCenterLeftControls}
                    renderCenterRightControls={renderCenterRightControls}
                    wrapAround
                    cellAlign={'center'}
                    autoplayInterval={5000}
                    renderBottomCenterControls={() => null}
                    autoPlay>
                    {quotes.map(({ age, text, author, description }, i) => (
                        <StyledQuoteFrame key={i}>
                            <StyledQuoteText>
                                <Nl2Br>{text}</Nl2Br>
                            </StyledQuoteText>
                            <StyledQuoteSignatureBlock>
                                <StyledTiltedTextContainer>
                                    <StyledTiltedText
                                        tiltedLeft
                                        noTextShadow
                                        borderColor={
                                            TPKColors.tiltedTextBorderB
                                        }
                                        backgroundColor={
                                            TPKColors.tiltedTextBackgroundB
                                        }>
                                        {author}
                                    </StyledTiltedText>
                                    <StyledTiltedText
                                        tiltedRight
                                        noTextShadow
                                        borderColor={
                                            TPKColors.tiltedTextBorderA
                                        }
                                        backgroundColor={
                                            TPKColors.tiltedTextBackgroundA
                                        }>
                                        {age}
                                    </StyledTiltedText>
                                </StyledTiltedTextContainer>
                                <StyledQuoteDescription>
                                    <b>{description}</b>
                                </StyledQuoteDescription>
                            </StyledQuoteSignatureBlock>
                        </StyledQuoteFrame>
                    ))}
                </StyledCarousel>
            </StyledCarouselContainer>
        </StyledCarouselFullPageContainer>
    )
}

const StyledQuoteText = styled.p`
    font-family: ${fonts.flameBold};
    font-size: 28px;
    br {
        display: none;
        ${media.small`display: inline;`}
    }
    ${media.medium`
        font-size: 42px;
    `}
    line-height: 1.3;
    color: ${colors.white};
    text-align: center;
    margin: 0;
`

const StyledQuoteDescription = styled.p`
    font-family: ${fonts.flameBold};
    font-size: 20px;
    ${media.medium`
        font-size: 24px;
    `}
    line-height: 1.38;
    color: ${colors.white};
    text-align: center;
    margin: 0;
`

const StyledQuoteSignatureBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
`

const StyledQuoteFrame = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 48px;
    background: ${TPKColors.carouselBlue};
    padding: 0 64px;
    box-sizing: border-box;
`

const StyledCarouselContainer = styled.div`
    display: flex;
    background: ${TPKColors.carouselBlue};
    align-self: center;
    justify-content: center;
    align-items: center;
    width: 100%;
    ${media.large`
       padding: 0 ${SPACING.XL};
    `}
`

const StyledCarouselFullPageContainer = styled.div`
    ${media.medium`
       padding: 92px 0;
       border-radius: ${BORDER.RADIUS.L};
    `}
    padding: 48px 0;
    display: flex;
    background: ${TPKColors.carouselBlue};
    align-self: center;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1280px;
    position: relative;
`

const StyledIconContainer = styled.div`
    display: flex;
    flex: 1;
    z-index: 1;
    top: 0;
    right: 0;
    img {
        position: absolute;
        top: -${SPACING.XXL};
        right: -${SPACING.XS};
        height: 86px;
    }
`

const StyledCarousel = styled(CarouselElement)`
    .slider-control-bottomcenter {
        display: none; // Hide the dots
    }

    &:focus,
    &:active {
        outline: none;
    }

    .slider-frame::before {
        content: ' ';
        position: absolute;
        background: linear-gradient(
            90deg,
            ${TPKColors.carouselBlue}FF 0%,
            ${TPKColors.carouselBlue}00 20%,
            ${TPKColors.carouselBlue}00 80%,
            ${TPKColors.carouselBlue}FF 100%
        );
        z-index: 1;
        height: 100%;
        width: 100%;
    }
`
